"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ButtonBase = _interopRequireDefault(require("../Button/ButtonBase"));
var _ThemeProvider = require("../ThemeProvider");
var _utils = require("../utils");
var _useCopy = _interopRequireDefault(require("../utils/useCopy"));
var _dictionary = _interopRequireDefault(require("./dictionary"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PageButton = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    label,
    onPress,
    href,
    isActive,
    copy,
    variant,
    tokens,
    ...props
  } = _ref;
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)('PaginationPageButton', tokens, variant);
  const getCopy = (0, _useCopy.default)({
    dictionary: _dictionary.default,
    copy
  });
  const getButtonTokens = buttonState => (0, _utils.selectTokens)('Button', getTokens(buttonState));
  const activeProps = isActive ? {
    selected: true,
    ..._utils.a11yProps.nonFocusableProps
    // a brute fix for the focus state being stuck on an active item since it becomes non-focusable
    // (see https://github.com/telus/universal-design-system/pull/577#issuecomment-931344107)
  } : {};
  const key = isActive ? 'active-item' : undefined;
  const accessibilityRole = href !== undefined ? 'link' : 'button';
  const activeLabel = isActive ? ` ${getCopy('currentLabel')}` : '';
  const accessibilityLabel = `${getCopy('goToLabel')} ${label}${activeLabel}`;
  const {
    hrefAttrs,
    rest
  } = _utils.hrefAttrsProp.bundle(props);
  const buttonProps = {
    accessibilityRole,
    accessibilityLabel,
    onPress,
    href,
    hrefAttrs,
    ...rest
  };
  return /*#__PURE__*/(0, _react.createElement)(_ButtonBase.default, {
    ref: ref,
    ...buttonProps,
    tokens: getButtonTokens,
    key: key,
    ...activeProps
  }, label);
});
PageButton.displayName = 'PageButton';
PageButton.propTypes = {
  ..._utils.linkProps.types,
  /**
   * To set custom label for the button
   */
  label: _propTypes.default.string,
  /**
   * To set `PageButton` to active state
   */
  isActive: _propTypes.default.bool,
  /**
   * To change the language for labels
   */
  copy: _utils.copyPropTypes,
  variant: _utils.variantProp.propType,
  tokens: (0, _utils.getTokensPropType)('PaginationPageButton')
};
var _default = exports.default = (0, _utils.withLinkRouter)(PageButton);